import { Text } from "@mantine/core"
import { showNotification } from "@mantine/notifications"
import { useTranslation } from "react-i18next"

interface CopyToClipboardProps {
  text: string
  className?: string
  style?: React.CSSProperties
  color?: string
}

export function CopyToClipboard({
  text,
  className = "",
  style = {},
  color,
}: CopyToClipboardProps) {
  const { t } = useTranslation()
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      showNotification({
        color: "green",
        message: t("copy", { text }),
      })
    } catch (error) {
      console.error("Failed to copy text: ", error)
    }
  }

  return (
    <Text className={className} style={style} onClick={handleCopy} c={color}>
      {text}
    </Text>
  )
}
